module.exports = "pegasus_template/assets/theme6/twitter.png";